import Home from "../components/Home";

function HomePage() {
  return <Home></Home>;
}
export default HomePage;
